import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.REALINHAMENTO.REALINHAMENTO.RESET_REALINHAR](state) {
		state.idAtaItem = null
		state.novoValor = null
		state.novaMarca = null
		state.justificativa = null
		state.fornecedorId = null
		state.idsExternoAnexoFlowbee = []
	},
}
